"use client";

import { useSelf } from "@/apiUtilities/queries/useSelf";
import { useUserStore } from "@/stores/useUserStore";
import { useLocale } from "next-intl";
import { useEffect, useRef } from "react";

declare global {
  interface Window {
    fcWidget: any;
  }
}

type FreshchatUser = {
  id: string;
  name?: string;
  email?: string;
  restoreId?: string;
};

type FreshchatProps = {
  user?: FreshchatUser | null;
  locale?: string
};

const FRESHCHAT_SCRIPT_ID = "Freshchat-js-sdk";
const TOKEN = "1cbc0012-1045-4b8a-9f62-6a5a932fdded"
const WIDGET_UUID = "3e7771d5-f261-4506-a218-d14381533173"
export default function Freshchat({ user }: FreshchatProps) {
  const locale = useLocale()
  const initialized = useRef(false);
  const lastUserId = useRef<string | null>(null);
  const { userId } = useUserStore()
  const { data: self, isSuccess } = useSelf({ enabled: !!userId })

  useEffect(() => {
    if(userId && isSuccess && locale !== undefined && locale !== '') {
      if (initialized.current) {
        if(window.fcWidget) {
          window.fcWidget.destroy()
          setTimeout(() => {
            window.fcWidget.init({
              token: TOKEN,
              widgetUuid: WIDGET_UUID,
              host: "https://sorastream.freshchat.com",
              locale: locale.substring(0,2),
              externalId: self.id,
              firstName: self.id
            })
            setTimeout(() => {
              window.fcWidget.user.setFirstName(self.id)
              window.fcWidget.user.setEmail(self.id)
              window.fcWidget.user.setProperties({
                plan: self.product.id,
                status: self.purchase.subs_status
              }) }, 1300)
          }, 1000)
        }
      };      
    }

    if(!userId) {
      if (initialized.current) {
        if(window.fcWidget) {
          window.fcWidget.destroy()
          setTimeout(() => {
            window.fcWidget.init({
              token: TOKEN,
              widgetUuid: WIDGET_UUID,
              host: "https://sorastream.freshchat.com",
              locale: locale.substring(0,2),
            });
          }, 1000)
        }
      }
    }
  }, [isSuccess, userId, locale])

  useEffect(() => {
    // console.log('LOCALE: ', locale)
    if(locale !== undefined && locale !== '') {
      function initFreshChat() {
        if (initialized.current) return;
        if (window.fcWidget) {
          window.fcWidget.init({
            token: TOKEN,
            widgetUuid: WIDGET_UUID,
            host: "https://sorastream.freshchat.com",
            locale: locale.substring(0,2),
          });

          initialized.current = true;
        }
      }

      function loadScript() {
        if (document.getElementById(FRESHCHAT_SCRIPT_ID)) {
          initFreshChat();
          return;
        }

        const script = document.createElement("script");
        script.id = FRESHCHAT_SCRIPT_ID;
        script.async = true;
        script.src = "https://sorastream.freshchat.com/js/widget.js";
        script.onload = initFreshChat;

        document.head.appendChild(script);
      }

      loadScript();
    }
  }, [locale]);

  useEffect(() => {
    if (!user) {
      // Si el usuario se desloguea
      if (window.fcWidget && lastUserId.current) {
        window.fcWidget.user.clear();
        lastUserId.current = null;
      }
      return;
    }

    const interval = setInterval(() => {
      if (!window.fcWidget) return;

      clearInterval(interval);

      // Si cambia de usuario → limpiar
      if (lastUserId.current && lastUserId.current !== user.id) {
        window.fcWidget.user.clear();
      }

      window.fcWidget.setExternalId(user.id);

      window.fcWidget.user.setProperties({
        firstName: user.name,
        email: user.email,
        ...(user.restoreId ? { restoreId: user.restoreId } : {}),
      });

      lastUserId.current = user.id;
    }, 400);

    return () => clearInterval(interval);
  }, [user]);
  // console.log('LOCALE RENDER: ', locale)
  return null;
}